import { render, staticRenderFns } from "./PaymentLogos.vue?vue&type=template&id=d1b62ba2&"
import script from "./PaymentLogos.vue?vue&type=script&lang=js&"
export * from "./PaymentLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports